import { defineMessages } from 'react-intl'

export default defineMessages({
  fallback_error_message: {
    id: 'error.fallback_error_message',
    defaultMessage: 'An error occurred, please try reloading the page',
  },
})
